module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_london.03ed0a85.pdf";